import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-300a9fd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "connection" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"state\" data-v-300a9fd6><div class=\"wrapper-process\" data-v-300a9fd6><div class=\"show-process\" data-v-300a9fd6><div class=\"processing\" data-v-300a9fd6></div></div></div><img class=\"logo\" src=\"/uidesk.png\" alt=\"\" srcset=\"\" data-v-300a9fd6><div class=\"text\" data-v-300a9fd6>Connection...</div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Decline = _resolveComponent("Decline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Decline, { onClick: _ctx.hangup }, null, 8, ["onClick"])
  ]))
}